import request from '@/utils/request'
let OrderApi = {
    /*订单列表*/
    orderlist(data, errorback) {
        return request._post('/shop/order.order/index', data, errorback);
    },
    /*订单详情*/
    orderdetail(data, errorback) {
        return request._post('/shop/order.order/detail', data, errorback);
    },
    /*售后管理*/
    orderrefund(data, errorback) {
        return request._post('/shop/order.refund/index', data, errorback);
    },
    /*去发货*/
    delivery(data, errorback) {
        return request._post('/shop/order.order/delivery', data, errorback);
    },
    /*确认审核*/
    confirm(data, errorback) {
        return request._post('/shop/order.Operate/confirmCancel', data, errorback);
    },
    /*售后详情*/
    refundDetail(data, errorback) {
        return request._get('/shop/order.refund/detail', data, errorback);
    },
    /*售后审核*/
    Approval(data, errorback) {
        return request._get('/shop/order.refund/audit', data, errorback);
    },
    /*确认收货并退款*/
    receipt(data, errorback) {
        return request._post('/shop/order.refund/receipt', data, errorback);
    },
    /*核销*/
    extract(data, errorback) {
        return request._post('/shop/order.operate/extract', data, errorback);
    },
    /*一键核销*/
    extractAll(data, errorback) {
        return request._post('/shop/order.operate/extractAll', data, errorback);
    },
    /*修改价格*/
    updatePrice(data, errorback) {
        return request._post('/shop/order.order/updatePrice', data, errorback);
    },
    /*批量发货*/
    batchDelivery(data, errorback) {
        return request._get('/shop/order.delivery/csv', data, errorback);
    },
    /*修改快递*/
    updateExpress(data, errorback) {
        return request._post('/shop/order.order/updateExpress', data, errorback);
    },
    /*修改收件地址*/
    updateAddress(data, errorback) {
        return request._post('/shop/order.order/updateAddress', data, errorback);
    },
    /*获取地址*/
    getArea(data, errorback) {
        return request._post('/shop/order.order/getArea', data, errorback);
    },
    /*物流轨迹*/
    getExpressTrack(data, errorback) {
        return request._post('/shop/order.express/track', data, errorback);
    },
    /*确认收货*/
    orderReceipt(data, errorback) {
        return request._post('/shop/order.order/receipt', data, errorback);
    },
}

export default OrderApi;



// WEBPACK FOOTER //
// ./src/api/order.js